module.exports = __webpack_public_path__ + "static/media/Article 2.b5e04bc0.svg";